module.exports = __webpack_public_path__ + "static/media/6dof.49aebb84.mp4";